module.exports = require('./controllersConfig').controllersConfig;
